import React, { useEffect, useState } from "react";
import { GetData } from "./Components/Services";
import Loading from "../../Common/Loading";
import CardList from "./Components/CardList";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import RenderBasket from "../../Common/RenderBasket";
import { webTemp, borderBottomTitle } from "../../../Utils/styles";
import { Link } from "react-router-dom";

function List({ isApp }) {
  const initialState = {
    loading: true,
    data: {
      data: null,
      current_page: null,
    },
    search: null,
  };

  const basket = useSelector(state => state.basket);
  const [form, setForm] = useState({ cat: false });

  const Empty = () => {
    return <h4 className="text-center my-5">مقاله ایی یافت نشد</h4>;
  };
  const [state, setState] = useState(initialState);
  useEffect(() => {
    Handler();
  }, []);

  const Handler = data => {
    if (data && data.category_id) {
      setForm({ cat: data.category_id });
    } else {
      setForm({ cat: false });
    }
    setState({ ...state, loading: true });
    GetData(data).then(result => {
      setState({
        loading: false,
        data: result,
      });
    });
  };

  const searchHandler = e => {
    e.preventDefault();
    Handler(state.search);
  };

  return (
    <>
      <Helmet>
        <title>مقالات | نیکوتن </title>

        <meta name="description" content={" مجله نیکوتن"} />
        <link rel="canonical" href={window.origin + "/blogs"} />
      </Helmet>
      <div
        style={{
          backgroundColor: "#F6F6F6",
        }}
      >
        <div style={!isApp ? { marginBottom: "20px" } : { padding: "20px 0", background: " white" }}>
          <section>
            <div className="container">
              <div className="row">
                <div className="col-12" style={!isApp ? { ...webTemp } : {}}>
                  <div
                    className="row pb-3"
                    style={{
                      ...borderBottomTitle,
                    }}
                  >
                    <div className="col-md-6">
                      <h1
                        style={{
                          fontSize: isApp ? "18px" : "23px",
                          textAlign: isApp && "center"
                        }}
                      >
                        همه مقالات
                      </h1>
                    </div>
                    {!isApp && <div className={"col-md-6"}>
                      <div className="row justify-content-end ">
                        <div className="col-md-2">
                          {" "}
                          <Link
                            to="/Weblog"
                            className="btn btn-red "
                            style={{
                              borderRadius: "15px",
                            }}
                          >
                            <img
                              src={
                                window.origin +
                                "/WebSide/assets/images/magh.png"
                              }
                              style={{ width: "20px", height: "20px" }}
                              alt="همه ملاقات"
                            />
                            <span>وبلاگ</span>
                          </Link>
                        </div>
                        <div className="col-md-5">
                          <div
                            className="d-flex  "
                            style={{
                              borderRadius: "15px",
                              boxShadow:
                                " rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
                              marginRight: "10px",
                              overflow: "hidden",
                            }}
                          >
                            <input
                              className="border-0 py-2 px-3"
                              placeholder="جست و جو در مقالات"
                              style={{ width: "200px" }}
                            />
                            <button
                              className="btn btn-red px-3"
                              style={{
                                borderRadius: "15px",
                              }}
                            >
                              <img
                                src={
                                  window.origin +
                                  "/WebSide/assets/images/search.png"
                                }
                                alt="همه ملاقات"
                                style={{ width: "20px", height: "20px" }}
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    }
                  </div>
                  {!isApp &&
                    <div className="d-flex align-items-center mt-3 flex-wrap">
                      {state.loading ? (
                        <Loading />
                      ) : (
                        <>
                          <button
                            onClick={() => {
                              Handler({ category_id: false });
                            }}
                            className={`${form.cat
                              ? "btn-blog-category"
                              : "btn-blog-category-select"
                              }`}
                            style={{ marginLeft: "10px" }}
                          >
                            همه مقالات
                          </button>
                          {state &&
                            state.data &&
                            state.data.blogCategories &&
                            state.data.blogCategories.map((cat, i) => {
                              return (
                                <button
                                  onClick={() => {
                                    Handler({ category_id: cat.id });
                                  }}
                                  key={i}
                                  className={`${cat.id == form.cat
                                    ? "btn-blog-category-select"
                                    : "btn-blog-category"
                                    }`}
                                  style={{ marginLeft: "10px" }}
                                >
                                  {cat.name}
                                </button>
                              );
                            })}
                        </>
                      )}
                    </div>
                  }
                  <div className="row ddddd">
                    {state.loading ? (
                      <Loading count={6} col={4} height={320} />
                    ) : state.data &&
                      state.data.blogs_list &&
                      state.data.blogs_list.data &&
                      state.data.blogs_list.data.length > 0 ? (
                      state.data &&
                      state.data.blogs_list.data.map((item, id) => {
                        return <CardList data={item} key={id} />;
                      })
                    ) : (
                      Empty()
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div >
        <RenderBasket basket={basket} />
      </div >
    </>
  );
}

export default List;
